// ════════════════════════════════════════════════════════════════════════════
// LỆCH PHIÊN BẢN SAU DEPLOY — NHÁNH THỨ HAI: "mảnh tải được nhưng THIẾU MÔ-ĐUN".
//
// 🩸 VÉ THẬT 05/08/2026 — /treatment (bản 1423b60):
//     TypeError: Cannot read properties of undefined (reading 'call')
//         at r  (…/_next/static/chunks/webpack-a87abefd15bee595.js:1:128)
//         at s  (…/_next/static/chunks/3200-075461d0cf4aef5e.js:1:115837)
//         at L  (…/_next/static/chunks/3200-075461d0cf4aef5e.js:1:119231)
//         at P  (…/_next/static/chunks/3200-075461d0cf4aef5e.js:1:116574)
//         at lf (…/_next/static/chunks/63a43dd3-….js:1:40724)   ← react-dom render
//
// ĐÃ GIẢI MÃ bằng chính bản dựng ở máy (mảnh 3200 TRÙNG BĂM với bản thật) + source map:
//   · `r` = `__webpack_require__` của webpack — thân hàm nguyên văn:
//         function r(o){ var n=t[o]; if(void 0!==n) return n.exports;
//                        var a=t[o]={exports:{}}; try{ e[o].call(…) } … }
//     Cột 128 rơi ĐÚNG vào `e[o].call` ⇒ `e[o]` (sổ mô-đun webpack) là **undefined**:
//     mã mô-đun được hỏi KHÔNG CÓ trong sổ của trình duyệt.
//   · `s`·`L`·`P` = `requireModule` · `initializeModuleChunk` · `readChunk` của
//     `react-server-dom-webpack/client.browser` (đã đối chiếu source map của mảnh 3200).
//   ⇒ Gói RSC máy chủ đẩy xuống trỏ tới một client component mà SỔ MÔ-ĐUN BÊN TRÌNH DUYỆT
//     không có ⇒ nổ ngay giữa lượt render.
//
// KHÔNG PHẢI LỖI MÃ NGUỒN. Đã rà máy: nạp cả 196 mảnh của bản dựng vào một sổ mô-đun giả rồi
// đối chiếu manifest client-reference của **154 route** — 0 route thiếu mô-đun. Bản dựng TỰ NÓ
// khớp. Thứ lệch là GIỮA HAI BẢN DỰNG: tab mở từ bản cũ (sổ mô-đun cũ trong bộ nhớ) đi tiếp
// sang trang mới, máy chủ lúc này đã là bản mới nên gói RSC mang mã mô-đun của BẢN MỚI. webpack
// thấy mảnh mang cùng SỐ HIỆU (3200) đã nạp rồi nên không tải lại bản băm mới ⇒ hỏi mã mô-đun
// mới trong sổ cũ ⇒ undefined. (Vé nổ ở bản 1423b60 đúng lúc c7ccd1b vừa lên — khớp giả thuyết.)
//
// VÌ SAO PHẢI TỰ TẢI LẠI, KHÔNG ĐỂ NGƯỜI DÙNG BẤM "THỬ LẠI":
// `reset()` của error boundary chỉ dựng lại cây React — sổ mô-đun trong bộ nhớ VẪN thiếu đúng
// mô-đun đó ⇒ render lại là nổ lại. Nút "Thử lại" thành NÚT CHẾT. Chỉ nạp lại trang mới kéo
// được bản JS mới về. `ChunkReloadGuard` đã chữa nhánh ANH EM (mảnh 404 → ChunkLoadError) từ
// 18/07; nhánh này cùng một gốc bệnh mà lọt lưới vì mảnh tải được, chỉ THIẾU RUỘT.
//
// ⚠️ LỌC THEO VẾT LỖI, KHÔNG THEO CÂU CHỮ (bài học 03/08 vụ `$RS`): "Cannot read properties of
// undefined (reading 'call')" là câu CHUNG CHUNG. Lọc theo câu chữ thì một bug thật cũng bị
// tưởng là lệch phiên bản → TỰ TẢI LẠI TRANG oan, che mất bug và quăng luôn thao tác đang dở.
// Nên bắt buộc phải có KHUNG BỘ NẠP WEBPACK trong vết lỗi — mã của app không bao giờ chạy ở đó.
// Đã rà repo: 0 chỗ dùng `.call(`/`.apply(` ⇒ câu "reading 'call'" không thể do mã mình sinh ra.
//
// THUẦN: không React, không DOM → test rà thẳng được (xem test/lech-phien-ban.test.ts).
// ════════════════════════════════════════════════════════════════════════════

/**
 * Khung vết lỗi nằm trong BỘ NẠP của webpack: `…/_next/static/chunks/webpack-<băm>.js`.
 * Đây là mảnh plumbing ~4KB do webpack tự sinh — KHÔNG một dòng mã nào của app nằm trong đó,
 * nên khung này xuất hiện = lỗi nổ ngay lúc nạp mô-đun, không phải trong mã nghiệp vụ.
 */
const KHUNG_BO_NAP_WEBPACK = /[/\\]static[/\\]chunks[/\\]webpack-[\w.-]*\.js/;

/**
 * Bốn cách các trình duyệt nói cùng một chuyện: "gọi `.call` trên `undefined`"
 * (= `__webpack_modules__[mã]` rỗng). Phải kể đủ vì hộp lỗi nhận vé từ mọi trình duyệt.
 */
const CAU_GOI_CALL_TREN_RONG = [
  /Cannot read properties of undefined \(reading 'call'\)/, // Chrome · Edge (V8 ≥ 65)
  /Cannot read property 'call' of undefined/, //               Chrome cũ · Android WebView
  /undefined is not an object \(evaluating '[^']*\.call'\)/, // Safari · iOS
  /\w+\[\w+\] is undefined/, //                                Firefox: "e[o] is undefined"
];

/**
 * Lỗi này có phải "tab cũ gặp bản mới" (mảnh tải được nhưng thiếu mô-đun) không?
 *
 * Phải khớp CẢ HAI vế mới nhận — hẹp là CỐ Ý, vì nhận nhầm = tự tải lại trang oan:
 *   ① vết lỗi có khung của bộ nạp webpack (mã app không bao giờ chạy ở đó), VÀ
 *   ② câu lỗi thuộc họ "gọi .call trên undefined".
 */
export function laLoiLechPhienBan(err: unknown): boolean {
  if (err == null) return false;
  const vet = String((err as { stack?: string }).stack ?? "");
  if (!KHUNG_BO_NAP_WEBPACK.test(vet)) return false; // ① không có khung webpack → không phải
  const cau = String((err as { message?: string }).message ?? "");
  return CAU_GOI_CALL_TREN_RONG.some((mau) => mau.test(cau)); // ②
}

// ── TỰ TẢI LẠI (dùng CHUNG cho mọi đường bắt lỗi) ───────────────────────────
// Khoá + bộ đếm để ở ĐÂY, không để riêng từng nơi: `ChunkReloadGuard` (nghe window) và
// `app/error.tsx` (error boundary) có thể cùng thấy MỘT sự cố. Hai bộ đếm riêng = hai lượt
// tải lại chồng nhau, tệ hơn là vòng lặp tải-lại nếu lỗi hoá ra là thật.
//
// ⚠️ ĐẾM SỐ LƯỢT, KHÔNG ĐẾM THỜI GIAN (sửa sau rà soát 05/08). Bản đầu chỉ ghi MỐC rồi chặn
// "nổ lại trong 15s". Sai ở chỗ mốc được ghi TRƯỚC `location.reload()` — tức là đếm từ lúc RA
// LỆNH, không phải lúc bản mới sẵn sàng. Mạng phòng khám chậm: tải + hydrate bản mới quá 15s thì
// hạn chờ đã hết TRƯỚC khi trang mới kịp nổ ⇒ lại đủ điều kiện tải lại ⇒ VÒNG LẶP theo nhịp ~15s
// (mỗi lượt lại quăng việc đang dở). Đếm lượt thì hạn chờ dài bao nhiêu cũng không sinh vòng lặp:
// hết ngân sách là dừng, dù mỗi lượt tải mất 3 giây hay 3 phút.
/** Khoá ghi mốc lần tự tải lại gần nhất. Giữ nguyên tên cũ của ChunkReloadGuard (từ 18/07). */
export const KHOA_MOC_TAI_LAI = "hd:chunk-reload-at";
/** Khoá đếm số lượt TỰ tải lại trong cùng một sự cố. */
export const KHOA_SO_LUOT_TAI_LAI = "hd:chunk-reload-count";
/**
 * Ngân sách TỰ tải lại cho một sự cố. 2 lượt vì lượt đầu có thể chưa đủ: gói RSC của trang còn
 * nằm trong router cache của Next nên trang vừa nạp lại vẫn có thể nổ y hệt một nhịp nữa.
 * Cạn ngân sách = tải lại KHÔNG chữa được (lỗi thật) → thôi, để người dùng thấy màn lỗi.
 */
export const SO_LUOT_TOI_DA = 2;
/**
 * Quá hạn này kể từ lượt tải lại gần nhất thì coi là SỰ CỐ KHÁC (deploy khác) → cấp lại ngân sách.
 * Không có nó thì một tab mở suốt buổi sẽ cạn ngân sách ở deploy thứ nhất rồi "chết cứng" ở các
 * deploy sau. 5 phút: dài hơn mọi lượt tải + hydrate thực tế, ngắn hơn khoảng cách 2 lượt deploy.
 */
export const HAN_QUEN_SU_CO_MS = 5 * 60_000;

/**
 * Trong CÙNG một lượt tải trang chỉ cho phép ra lệnh tải lại MỘT lần. Sống theo lượt tải trang
 * (nạp lại trang = mô-đun mới = cờ về `false`), nên không cần khử trùng bằng thời gian: hai đường
 * bắt lỗi cùng thấy một sự cố sẽ KHÔNG đốt hai suất trong ngân sách ở trên.
 */
let daRaLenhTaiLaiLuotNay = false;

/**
 * Tải lại trang để kéo bản JS mới về, TỐI ĐA `SO_LUOT_TOI_DA` lượt mỗi sự cố. Trả `true` nếu đã
 * ra lệnh tải lại, `false` nếu đã cạn ngân sách (hoặc lượt tải trang này ra lệnh rồi) — nơi gọi
 * cứ hiện lỗi bình thường.
 */
export function tuTaiLaiMotLan(): boolean {
  if (daRaLenhTaiLaiLuotNay) return false;
  try {
    const mocCu = Number(sessionStorage.getItem(KHOA_MOC_TAI_LAI) ?? "0");
    const bayGio = Date.now();
    // Mốc quá cũ (hoặc rác/không đọc được) → sự cố khác → đếm lại từ 0.
    const cungSuCo = mocCu > 0 && bayGio - mocCu < HAN_QUEN_SU_CO_MS;
    const soLuot = cungSuCo ? Number(sessionStorage.getItem(KHOA_SO_LUOT_TAI_LAI) ?? "0") || 0 : 0;
    if (soLuot >= SO_LUOT_TOI_DA) return false; // cạn ngân sách → tải lại không chữa được
    sessionStorage.setItem(KHOA_MOC_TAI_LAI, String(bayGio));
    sessionStorage.setItem(KHOA_SO_LUOT_TAI_LAI, String(soLuot + 1));
  } catch {
    // sessionStorage bị chặn (chế độ riêng tư…) → vẫn tải lại; cờ `daRaLenhTaiLaiLuotNay` ở trên
    // vẫn chặn được trùng trong lượt này, chỉ mất trần liên-lượt (rủi ro lặp rất hiếm).
  }
  daRaLenhTaiLaiLuotNay = true;
  window.location.reload();
  return true;
}

/**
 * Người dùng CHỦ ĐỘNG bấm "Thử lại" ở màn lỗi lệch phiên bản → nạp lại trang NGAY, BỎ QUA ngân
 * sách ở trên. Ngân sách chỉ để chặn máy tự lặp; người bấm là đã thấy màn lỗi và cố ý thử tiếp,
 * chặn họ lại = "nút chết" lần thứ hai. Cũng KHÔNG dùng `reset()` của error boundary: reset chỉ
 * dựng lại cây React, sổ mô-đun trong bộ nhớ VẪN thiếu mô-đun và gói RSC cũ VẪN trong router
 * cache ⇒ nổ y hệt. Chỉ một lượt tải trang thật mới đổi được cả hai.
 */
export function taiLaiThuCong(): void {
  window.location.reload();
}
